import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../../../../aumico-lib-core-fe/src/lib/services/localStorage.service';

@Component({
    selector: 'app-page-redirect',
    templateUrl: './redirect.page.html',
    styleUrls: ['./redirect.page.scss'],
})
export class RedirectPage implements OnInit {
    constructor(private router: Router, private localStorageService: LocalStorageService) {}

    ngOnInit(): void {
        const currentLanguage = this.localStorageService.getCurrentLanguage();
        this.router.navigateByUrl(`${currentLanguage}`);
    }
}
